import axiosInstance from "@/api/axiosInstance";

export class ActivityService {
  private readonly basePath: string;

  constructor(basePath = "/activities") {
    this.basePath = basePath;
  }

  public async createAdminComment(
    message: string,
    publicReference: string
  ): Promise<any> {
    const url = `/api/v1${this.basePath}/${publicReference}`;
    const offerObject = {
      message: message,
    };
    await axiosInstance.post(url, offerObject);
  }

  public async listComments(publicReference: string): Promise<any> {
    const url = `/api/v1${this.basePath}/${publicReference}`;
    return await axiosInstance.get(url);
  }
}
